import React from "react";
import CookieConsent from "react-cookie-consent";
import { useLocation } from "@reach/router"; // this helps tracking the location
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";
import { Link } from "gatsby";
import { Helmet } from "react-helmet";

const GdprPanel = () => {
  const location = useLocation();
  const inEu = Intl.DateTimeFormat()
    .resolvedOptions()
    .timeZone.startsWith("Europe")
    ? true
    : false;

  if (inEu === true) {
    return (
      <CookieConsent
        onAccept={() => {
          initializeAndTrack(location);
        }}
        location="bottom"
        buttonClasses="btn btn-primary"
        containerClasses="meridian-cc"
        contentClasses="col-lg-9"
        buttonText="Accept"
        enableDeclineButton
        declineButtonText="Decline"
        cookieName="gatsby-gdpr-google-tagmanager"
        declineButtonClasses="btn btn-decline"
        overlay
      >
        <strong>Notice.</strong> Meridian University uses cookies to provide
        necessary website functionality, improve your experience and analyze our
        traffic. By using our website, you agree to our{" "}
        <Link to="/terms-of-services" className="cc-link">
          Terms of Service
        </Link>{" "}
        and{" "}
        <Link to="/privacy" className="cc-link">
          Privacy Policy
        </Link>
        .
      </CookieConsent>
    );
  } else {
    return (
      <Helmet>
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-5KMPB6C')`}
        </script>
      </Helmet>
    );
  }
};

export default GdprPanel;
